import graphql__18326742c453b809fe77 from "./__generated__/UnlockAccountMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__18326742c453b809fe77;

function unlockAccount(variables, onCompleted) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { unlockAccount };
